var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpertPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5545 15.5391L16.6606 13.2991C16.5208 13.1913 16.3465 13.138 16.1703 13.1494C15.9941 13.1608 15.8281 13.236 15.7034 13.3609L14.1673 14.8977C14.0529 15.0132 13.9028 15.0868 13.7414 15.1065C13.58 15.1261 13.4166 15.0907 13.2778 15.006C12.7832 14.7027 11.9556 14.1151 10.9199 13.0788C9.88417 12.0439 9.2965 11.2155 8.99321 10.7217C8.90838 10.583 8.87299 10.4197 8.8928 10.2583C8.91261 10.0969 8.98645 9.94702 9.10231 9.83296L10.6384 8.29624C10.7635 8.17158 10.8388 8.00551 10.85 7.82925C10.8613 7.653 10.8077 7.4787 10.6995 7.33915L8.46009 4.44462C7.95097 3.7879 6.99091 3.6839 6.36542 4.23299C5.54138 4.95589 4.5515 6.03879 4.26349 7.25406C3.742 9.44314 4.56605 12.19 8.18807 15.8118C11.8101 19.4329 14.5572 20.2576 16.7457 19.7369C17.961 19.4474 19.0447 18.4569 19.7676 17.6336C20.316 17.0082 20.212 16.0482 19.5545 15.5391Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertPhone);
export default __webpack_public_path__ + "static/media/expertPhone.61f81203564d63f5c85c07e4d1e3321c.svg";
export { ForwardRef as ReactComponent };